import { useId } from 'react';

import { SWATCHES } from '../constants';
import styles from './ColourRow.module.css';

interface Props {
  value: string;
  onChange: (colour: string) => void;
}

/** Four preset swatches plus a native colour input behind a rainbow chip. */
export function ColourRow({ value, onChange }: Props): React.JSX.Element {
  const pickerId = useId();
  const selected = value.toLowerCase();

  return (
    <div className={styles.group}>
      <p className={styles.label}>Grid &amp; label colour</p>
      <div className={styles.row} role="group" aria-label="Grid and label colour">
        {SWATCHES.map((colour) => (
          <button
            key={colour}
            type="button"
            className={styles.swatch}
            data-selected={selected === colour.toLowerCase()}
            style={{ background: colour }}
            onClick={() => onChange(colour)}
            aria-label={`Grid colour ${colour}`}
            aria-pressed={selected === colour.toLowerCase()}
          />
        ))}

        <label className={styles.picker} htmlFor={pickerId} title="Any colour">
          <span aria-hidden="true">+</span>
          <input
            id={pickerId}
            type="color"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            aria-label="Pick any grid colour"
          />
        </label>
      </div>
    </div>
  );
}
